import { AlphaYBoxIcon } from './AlphaYBoxIcon';

/**
 * author: GreenTurtwig
 * id 00418BEF-11B7-4644-8F57-3CBB7D8F9760
 * name alpha-y-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-y-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterYBoxIcon = AlphaYBoxIcon;
export default LetterYBoxIcon